document.addEventListener('alpine:init', () => {

    Alpine.data('infiniteScroll', (config = {}) => ({
        products: config.initialProducts || [],
        page: 1,
        loading: false,
        hasMore: true,
        perPage: config.perPage || 12,
        category: config.category || null,
        search: config.search || null,
        observer: null,

        init() {
            this.setupIntersectionObserver();
        },

        setupIntersectionObserver() {
            const sentinel = document.getElementById('scroll-sentinel');
            if (!sentinel) return;

            this.observer = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && !this.loading && this.hasMore) {
                    this.loadMore();
                }
            }, {
                rootMargin: '200px'
            });

            this.observer.observe(sentinel);
        },

        async loadMore() {
            this.loading = true;
            this.page++;

            try {
                const response = await frappe.call({
                    method: 'tos_webcommerce.api.product.get_products',
                    args: {
                        page: this.page,
                        per_page: this.perPage,
                        category: this.category,
                        search: this.search
                    }
                });

                if (response.message && response.message.products) {
                    this.products = [...this.products, ...response.message.products];
                    this.hasMore = response.message.has_more;

                    this.renderProducts(response.message.products, response.message.cards_html);
                }
            } catch (error) {
                console.error('Failed to load products:', error);
            }

            this.loading = false;
        },

        renderProducts(newProducts, cardsHtml) {
            const grid = document.querySelector('.products-grid');
            if (!grid) return;

            // get_products always returns server-rendered cards_html; keep one source of
            // truth for card markup (templates/includes/product_card.html).
            (cardsHtml || []).forEach((html) => {
                if (html) {
                    grid.insertAdjacentHTML('beforeend', html);
                }
            });
        },

        destroy() {
            if (this.observer) {
                this.observer.disconnect();
            }
        }
    }));

    Alpine.data('videoModal', () => ({
        open: false,
        url: '',
        title: '',

        show(url, title) {
            this.url = url;
            this.title = title || '';
            this.open = true;
            document.body.style.overflow = 'hidden';
        },

        hide() {
            this.open = false;
            this.url = '';
            this.title = '';
            document.body.style.overflow = '';

            const video = this.$refs.videoPlayer;
            if (video) {
                video.pause();
            }
        }
    }));
});

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.banner-carousel').forEach((el, index) => {
        if (typeof Glide !== 'undefined' && el.id) {
            new Glide(`#${el.id}`, {
                type: 'slider',
                rewind: false,
                bound: true,
                perView: 1,
                autoplay: 5000,
                hoverpause: true,
                animationDuration: 500
            }).mount();
        }
    });

    document.querySelectorAll('.category-carousel').forEach((el, index) => {
        if (typeof Glide !== 'undefined' && el.id) {
            new Glide(`#${el.id}`, {
                type: 'slider',
                rewind: false,
                bound: true,
                perView: 8,
                gap: 16,
                breakpoints: {
                    1280: { perView: 7 },
                    1024: { perView: 6 },
                    768: { perView: 5 },
                    640: { perView: 4 },
                    480: { perView: 3 }
                }
            }).mount();
        }
    });

    document.querySelectorAll('.flash-sale-carousel').forEach((el, index) => {
        if (typeof Glide !== 'undefined' && el.id) {
            new Glide(`#${el.id}`, {
                type: 'slider',
                rewind: false,
                bound: true,
                perView: 5,
                gap: 16,
                breakpoints: {
                    1280: { perView: 4 },
                    1024: { perView: 3 },
                    768: { perView: 2.5 },
                    480: { perView: 1.5 }
                }
            }).mount();
        }
    });
});

function scrollToSection(sectionId) {
    const element = document.getElementById(sectionId);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
}

function applySorting(value) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort', value);
    window.location.href = url.toString();
}

function applyCategory(category) {
    const url = new URL(window.location.href);
    if (category) {
        url.searchParams.set('category', category);
    } else {
        url.searchParams.delete('category');
    }
    url.searchParams.delete('page');
    window.location.href = url.toString();
}

window.shopCMS = {
    scrollToSection,
    applySorting,
    applyCategory
};
